import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Dropdown, Form, InputGroup} from 'react-bootstrap';
import CurrencyInput from "react-currency-input-field";
import SvgIcon from "../../../../../components/svg-icon";


const TryBankDropdown = ({bank, bankList, setBank, amount, setAmount}) => {

    const {t} = useTranslation()
    const [searchTerm, setSearchTerm] = useState('')
    const [show, setShow] = useState(false);
    const [bankListFiltered, setBankListFiltered] = useState([]);
    const dropdownRef = useRef(null);


    // Handle click outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);


    return (
        <>

            <Dropdown
                ref={dropdownRef}
                className="modal__wallet-dropdown modal__wallet-dropdown--double-big dropdown"
                show={show}
                onToggle={() => setShow(!show)}
            >
                <Dropdown.Toggle
                    className="modal__wallet-dropdown-btn"
                    id="modalWallet0"
                    aria-expanded={show}
                    disabled={bankList?.length <= 0}
                    onClick={() => setShow(!show)}
                >
                    {bank?.bankName || t('general.select-bank','Bank')}
                    <SvgIcon id={'right-down'}/>
                </Dropdown.Toggle>

                <Dropdown.Menu className="modal__wallet-menu" aria-labelledby="modalWallet0">
                    <div className="modal__wallet-search">
                        <div className="search">
                            <InputGroup>
                                <Form.Control
                                    value={searchTerm}
                                    onChange={e => setSearchTerm(e.target.value)}
                                    type="text"
                                    className="search__input"
                                    placeholder={t('general.search')}
                                />
                            </InputGroup>
                        </div>
                    </div>

                    <ul className="modal__wallet-currencies">
                        {
                            bankList?.map(nett => (
                                <li onClick={e => {
                                    setBank(nett)
                                    setShow(false)
                                }} key={nett?.bankName}>
                                <span className="gapp2">
                                    {nett?.bankName}
                                </span>
                                </li>
                            ))
                        }
                    </ul>
                </Dropdown.Menu>
            </Dropdown>


            <div className="modal__wallet-dropdown modal__wallet-dropdown--double-big dropdown">

                {/*<label htmlFor="" className="form__label">*/}
                {/*    TRY Amount*/}
                {/*    <b>*</b>*/}
                {/*</label>*/}
                <CurrencyInput
                    decimalsLimit={2}
                    className="form__input  "
                    prefix={'TRY '}
                    value={amount}
                    placeholder={'TRY Amount'}
                    onValueChange={(value) => setAmount(value)}

                />
            </div>

        </>

    )

}


export default TryBankDropdown
